import { defineStore } from 'pinia'
import { getMngInstList } from '@/service/common.service'

// localStorage 키
const STORAGE_KEY = {
    INST_ID: 'SELECTED_INST',
    INST_NM: 'SELECTED_INST_NM'
}

export const useInstStore = defineStore('inst', {
    state: () => ({
        instOptions: [],
        selectedInst: localStorage.getItem(STORAGE_KEY.INST_ID) || '',
        selectedInstNm: localStorage.getItem(STORAGE_KEY.INST_NM) || ''
    }),

    actions: {
        // 기관 목록 로드
        async loadInstList() {
            // localStorage에서 최신 값 동기화
            this.selectedInst = localStorage.getItem(STORAGE_KEY.INST_ID) || ''
            this.selectedInstNm = localStorage.getItem(STORAGE_KEY.INST_NM) || ''
            
            // 이미 로드된 경우 skip
            if (this.instOptions.length > 0) return

            const res = await getMngInstList()
            
            let dataList = []
            if (res?.data?.body?.data && Array.isArray(res.data.body.data)) {
                dataList = res.data.body.data
            } else if (res?.data && Array.isArray(res.data)) {
                dataList = res.data
            } else if (Array.isArray(res)) {
                dataList = res
            }
            
            if (dataList.length > 0) {
                this.instOptions = dataList.map(item => ({
                    label: item.instNm,
                    value: item.instId
                }))
            }
        },

        // 기관 변경 (Header에서 사용)
        changeInst(instId) {
            if (!instId || this.selectedInst === instId) return

            this.selectedInst = instId
            localStorage.setItem(STORAGE_KEY.INST_ID, instId)

            const instNm = this.instOptions.find(o => o.value === instId)?.label || ''
            this.selectedInstNm = instNm
            localStorage.setItem(STORAGE_KEY.INST_NM, instNm)

            // 기관 변경 시 메인으로 이동 + 전체 새로고침 (기존 컴포넌트 상태 초기화)
            window.location.href = '/'
        }
    }
})
